angular.module('gym.calendar').directive('eventAppearanceSelect', ["$window", function($window) {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/event_appearance_select.html.slim'),
    scope: {
      event: '='
    },
    controller: ["$scope", "EventService", "FeatureAvailabilityService", function($scope, EventService, FeatureAvailabilityService) {
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.eventAppearance = [];
      $scope.eventAppearanceKeys = function(scope) {
        return `${scope.event.show_in_kiosk_mode}${scope.event.show_in_book_and_pay}${scope.event.website_hidden}${scope.event.show_in_roll_call}`;
      };
      $scope.$watch($scope.eventAppearanceKeys, function() {
        return $scope.eventAppearance = EventService.getEventAppearance($scope.event);
      });
      $scope.eventAppearanceOptions = EventService.getEventAppearanceOptions();
      return $scope.onEventAppearanceChange = function() {
        var updated;
        updated = {
          website_hidden: $scope.eventAppearance.indexOf('website_hidden') < 0,
          show_in_book_and_pay: $scope.eventAppearance.indexOf('show_in_book_and_pay') >= 0,
          show_in_kiosk_mode: $scope.eventAppearance.indexOf('show_in_kiosk_mode') >= 0,
          show_in_roll_call: $scope.eventAppearance.indexOf('show_in_roll_call') >= 0
        };
        return angular.extend($scope.event, updated);
      };
    }]
  };
}]);
